export const forums = {
  forumsSearchInputPlaceholder: 'Search',
  forumsFollowDiscussionButtonTitle: 'Follow',
  forumsFollowingDiscussButtonTitle: 'Following',
  forumDiscussionInfoNoReplyText: 'No replies yet',
  forumsDiscussionDetailsStartButtonTitle: 'Start discussion',
  forumDetailsCreatedByText: 'by',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Copy link',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Flag content',
  forumsReportedCurtainContent: 'Content reported',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Link copied!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Pin discussion',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Unpin discussion',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Edit discussion',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Delete discussion',
  forumsDiscussionDetailspPopupDeleteTitle: 'Delete',
  forumsDiscussionDetailspPopupDeleteText: 'Delete this discussion?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Cancel',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Confirm',
  forumsDiscussionDetailsDeleledAlertText: 'Discussion deleted!',
  forumsNewDiscussionTitle: 'New discussion',
  forumsNewDiscussionTitlePlaceholder: 'Title...',
  forumsNewDiscussionBodyPlaceholderText: 'Place your text here...',
  forumsNewDiscussionPublishButtonTitle: 'Publish',
  forumsNewDiscussionLocationCurtainTitle: 'Location',
  forumsNewDiscussionLocationCurtainInputPlaceholder: 'Location name',
  forumsNewDiscussionEditLocationCurtainText: 'Edit location',
  forumsNewDiscussionDeleteLocationCurtainText: 'Delete location',
  forumsNewDiscussionCreatePollTitle: 'Create poll',
  forumsNewDiscussionTitleInputPlaceholder: 'Title',
  forumsNewDiscussionOptionInputPlaceholder: 'Option',
  forumsNewDiscussionAddButtonTitle: 'Add option',
  forumsNewDiscussionCreateButtonTitle: 'Create',
  forumsNewDiscussionPollTitleBlankAlertText: 'Title can’t be blank!',
  forumsNewDiscussionPollOptionBlankAlertText: 'Option can’t be blank!',
  forumsNewDiscussionPollLongTitleAlertText: 'Title should contain at most 140 characters',
  forumsNewDiscussionPollLongOptionAlertText: 'Option should contain at most 25 characters',
  forumsNewDiscussionEditPollIconText: 'Edit poll',
  forumsNewDiscussionRemovePollIconText: 'Remove  poll',
  forumsDiscardDraftPopupTitle: 'Draft',
  forumsDiscardDraftPopupText: 'Discard this Draft?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Cancel',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Confirm',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Reply',
  forumsDiscussionDetailsNoCommentsText: 'There are no comments yet\nYou can leave the first one',
  forumsDiscussionDetailsReplyInputPlaceholder: 'Reply',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Copy link',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Link copied!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Flag content',
  forumsDiscussionDetailsPostCurtainReportedText: 'Content reported',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Reply',
  forumsEditDiscussionTitle: 'Edit discussion',
  forumsEditDiscussionSaveButtonTitle: 'Save',
  forumsEditedDiscussionSavedAlertText: 'Discussion saved!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Edit reply',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Delete reply',
  forumsDiscussionDetailsEditedCommSavedAlertText: 'Comment saved!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: 'Comment deleted!',
  forumsAlertSomethinWrong: 'Something went wrong!',
  forumsMaxMbSize: 'You can upload no more than {size} MB at once',
  forumsMaxAttachments: 'You have exceeded max number of attachments. Max attachments is {max}',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Delete',
  forumsDiscussionDetailsDeleteCommentPopupText: 'Delete this Comment?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Cancel',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Confirm',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Flag content',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Content reported',
  forumDiscussionInfoLastReplyText: 'Last reply',
  forumsDiscussionAt: 'at',
  forumsDiscussionDetailsFlagCurtainTitle: 'Flag',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Content reported',
  forumsPollInfoVotesText: 'votes',
  forumsPollInfoEditVoteText: 'Edit vote',
  forumsPollFinishPollText: 'Finish the poll',
  forumsPollFinishedPollText: 'Finished',
  forumsPollInProgresslText: 'In Progress',
  forumsPollCurtainTitle: 'Finish the poll',
  forumsPollCurtainText: 'Users won’t be able to vote after the poll is finished.',
  forumsFinishPollCurtainCancelButtonTitle: 'Cancel',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Confirm',
  forumsPollInfoPollVotesCurtainTitle: 'Poll Votes'
}
